
var Params 					= require("$root/common/variables/Params.es6");
var Util 						= require("$root/common/util/Util.es6");
var easing 					=	require("jquery.easing");
window.$ 						= require("jquery");
window.Jquery 			= window.$

//localStorageの下方互換を確保
if (!window.localStorage)
{
	window.localStorage = {};
}

window.$.wait = function(msec) {
	var df_ = new $.Deferred;
	setTimeout(function(){df_.resolve(msec);}, msec);
	return df_.promise();
};



class Main
{

	constructor()
	{

		Params.IS_MOBILE = Params.MOBILE_VIEW.indexOf(Util.getUserAgent()) != -1;
		Params.IS_TABLET = Params.TABLET_VIEW.indexOf(Util.getUserAgent()) != -1;
		this.isStart = false;
		this.timer = -1;
		this.pastMouseX = 0;
		this.body = $("body");
		this.menu = $("#menu");
		this.menuIcon = $("#menu_icon");
		this.wrapper = $("#wrapper");
		this.isOpenMenu = false;
		this.header = $("#header");
		this.headerIcon = null;
		this.cv = $("#cover");
		this.slides = [];

		this.slides[0] = $(".result");
		this.slides[1] = $(".talkshow");
		this.ticker = 0;

		this.mouseOver = false;

		this.slides[0].mouseover(()=>{this.mouseOver = true});
		this.slides[0].mouseout(()=>{this.mouseOver = false});

		this.slides[1].mouseover(()=>{this.mouseOver = true});
		this.slides[1].mouseout(()=>{this.mouseOver = false});

		if(this.cv[0])
		{
			this.tl = $("#cover > .top-left");
			this.mr = $("#cover > .mid-right");
			this.ml = $("#cover > .mid-left");
			this.br = $("#cover > .bottom-right");
		}

		this.$award = $("#award");
	
		if(this.$award[0])
		{
			
			this.$descs = this.$award.find(".desc");
			this.$comments = this.$award.find(".comments");
		}

		if(this.header[0])
		{
			this.headerIcon = $(this.header.find(".icon"));
		}

		window.addEventListener("resize", ()=>{this.onResize();});

		if(!Params.IS_MOBILE && !Params.IS_TABLET)
		{
			$(document).mousemove((e)=>
				{
					this.mouseX = e.pageX;
					this.mouseY = e.pageY;
					if(this.pastMouseX == 0) this.pastMouseX = this.mouseX;
				}
			).mouseover(); // call the handler immediately
		}
		else {
			this.menuIcon.on("click", (e)=>{
				if(!this.isOpenMenu)
				{
					this.menu.addClass("open");
					this.wrapper.addClass("menu-open");
					this.body.addClass("menu-open");
					this.isOpenMenu = true;
					// this.menuIcon.addClass("hide")
				}
				else
				{
					this.menu.removeClass("open");
					this.wrapper.removeClass("menu-open");
					this.body.removeClass("menu-open");
					this.isOpenMenu = false;
				}
			});

			this.menu.on("click", (e)=>{
				if(this.isOpenMenu)
				{
					this.menu.removeClass("open");
					this.wrapper.removeClass("menu-open");
					this.body.removeClass("menu-open");
					this.isOpenMenu = false;
				}
			});
		}


		this.menus = this.menu.find("li");

		for(var i = 0; i < this.menus.length; i++)
		{
			if(!$(this.menus[i]).hasClass("n"))
			{
				var s_ = $(this.menus[i]).find("a");
				if(s_)
				s_.on("click",(e)=>{this.changeHash();});
			}
		}


		this.onResize();
		if(this.cv[0]) this.changeHash();

		var count = 0;
		this.slides[count].addClass("show");

		setInterval(() => {
			if(this.mouseOver) return;
			this.slides[count].removeClass("show");
			count = (count + 1) % this.slides.length;
			this.slides[count].addClass("show");
		}, 3000);


		requestAnimationFrame(()=>{this.update();})
	}

	changeHash()
	{
		clearTimeout(this.hashTimer);
		this.hashTimer = setTimeout(
			()=>
			{
				var _scroll = 0;
				var hash_ = location.hash;

				switch(hash_)
				{
					case "#01":
						_scroll = $("#top > .section01").get( 0 ).offsetTop
						break;
					case "#02":
						_scroll = $("#top > .section02").get( 0 ).offsetTop
						break;
					case "#03":
						_scroll = $("#top > .section03").get( 0 ).offsetTop
						break;
					case "#04":
						_scroll = $("#top > .section04").get( 0 ).offsetTop
						break;
					case "#05":
						_scroll = $("#top > .section05").get( 0 ).offsetTop
						break;
				}
				console.log(_scroll)
				if(_scroll > 0) $('html,body').animate({scrollTop: _scroll-100}, 500, 'easeOutQuart');
			}
		,200)

	}

	update()
	{

		if(Params.IS_MOBILE || Params.IS_TABLET)
		{
			this.menuIcon.removeClass("hide")
		}
		else
		{
			if(!this.isOpenMenu && this.mouseX < 100)
			{
				this.menu.addClass("open");
				this.wrapper.addClass("menu-open");
				this.body.addClass("menu-open");
				this.isOpenMenu = true;
				// this.menuIcon.addClass("hide")
			}
			else if(this.isOpenMenu && this.mouseX > 340)
			{
				this.menu.removeClass("open");
				this.wrapper.removeClass("menu-open");
				this.body.removeClass("menu-open");
				this.isOpenMenu = false;
				// this.menuIcon.removeClass("hide")
			}

			if(this.body.scrollTop() < $(window).height() - 80 && location.pathname == "/")
			{
				if(this.mouseX != this.pastMouseX || this.body.scrollTop() != this.pastScroll)
				{
					clearTimeout(this.timer);
					this.timer = setTimeout(
						()=>
						{
							this.menuIcon.addClass("hide")
						}
					,1000);
					this.menuIcon.removeClass("hide")
				}
			}
			else {
				clearTimeout(this.timer);
				this.menuIcon.removeClass("hide")
			}

			this.pastScroll = this.body.scrollTop();
			this.pastMouseX = this.mouseX;

		}

		if(this.headerIcon)
		{
			// if(this.body.scrollTop() > 40)
			// {
			// 	this.headerIcon.show()
			// }
			// else {
			// 	this.headerIcon.hide()
			// }
		}
		
		var yt = $(".yt");
		if(yt.length > 0) {
			$(yt).height($(yt).width() * 0.5625);
		}
		requestAnimationFrame(()=>{this.update();})
	}

	onResize()
	{

		if(this.$award[0])
		{
			for (let i = 1; i < this.$descs.length; i++) 	$(this.$descs[i]).height("auto");
			for (let i = 1; i < this.$comments.length; i++) $(this.$comments[i]).height("auto");
			for (let i = 1; i < this.$descs.length; i+=2){
				var h_ = $(this.$descs[i]).height();
				h_ = h_ > $(this.$descs[i+1]).height() ? h_ : $(this.$descs[i+1]).height();
				$(this.$descs[i]).height(h_);
				$(this.$descs[i+1]).height(h_);
			}

			for (let i = 1; i < this.$comments.length; i+=2){
				var h_ = $(this.$comments[i]).height();
				h_ = h_ > $(this.$comments[i+1]).height() ? h_ : $(this.$comments[i+1]).height();
				$(this.$comments[i]).height(h_);
				$(this.$comments[i+1]).height(h_);
			}
		}

		if(!this.cv[0]) return false;
		if(Params.IS_MOBILE || Params.IS_TABLET)
		{
			this.cv.height($(window).height())
		}
		else {
			this.cv.height($(window).height() - 80)
		}

		var s_ = 80;
		var st_ = 80;
		if($(window).width() < 641)
		{
			s_ = 30;
			st_ = 80;
		}

		// $(this.mr).css("top", (this.cv.height()-$(this.mr).height())/2)
		// var brh_ = $(this.br).height();
		// var tly_ = $(this.tl).offset().top;
		// var tlh_ = $(this.tl).height();

		// $(this.mr).css("top", tly_ + tlh_ + tlh_*0.3);

		// var mry_ = $(this.mr).offset().top;
		// var mrh_ = $(this.mr).height();

		// $(this.ml).css("top", mry_ + mrh_ + tlh_*0.3);

		// if($(window).height() < try_ + trh_  + s_*2 + brh_ + s_+3) $(this.br).css("top", try_ + trh_ + trh_*0.2);
		// else  $(this.br).css("top", "auto");


		if(!this.isStart)
		{
			this.wrapper.removeClass("hide")
			// $(this.tl).removeClass("hide")
			// $(this.br).removeClass("hide")
			// $(this.mr).removeClass("hide")
			this.isStart = true;
		}
		
	}
}


$(document).ready(
	function()
	{
		var main = new Main();
	}
);

module.exports = Main;
